import { render, staticRenderFns } from "./AddNotesModal.vue?vue&type=template&id=4e1c8e39&scoped=true"
import script from "./AddNotesModal.vue?vue&type=script&lang=ts"
export * from "./AddNotesModal.vue?vue&type=script&lang=ts"
import style0 from "./AddNotesModal.vue?vue&type=style&index=0&id=4e1c8e39&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1c8e39",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e1c8e39')) {
      api.createRecord('4e1c8e39', component.options)
    } else {
      api.reload('4e1c8e39', component.options)
    }
    module.hot.accept("./AddNotesModal.vue?vue&type=template&id=4e1c8e39&scoped=true", function () {
      api.rerender('4e1c8e39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/AddNotesModal.vue"
export default component.exports